import { forwardRef } from 'react'
import { MessageButtonProps } from './types'
import { Button } from 'atoms/button'
import { MessageTypeEnum } from 'constants/call'

// eslint-disable-next-line react/display-name
export const MessageButton = forwardRef<HTMLDivElement, MessageButtonProps>(
  ({ type, text, isGrouped, onClick, isClicked }, ref) => {
    if (isClicked) return null

    return (
      <div
        ref={ref}
        className={`flex flex-col space-y-2 ${
          isGrouped ? 'mt-[10px]' : 'mt-[40px]'
        }`}
      >
        <div
          className={`flex items-center space-x-2 ${
            type === MessageTypeEnum.incoming ? 'justify-start' : 'justify-end'
          }`}
        >
          <Button className="w-full" variant="default" onClick={onClick}>
            {text}
          </Button>
        </div>
      </div>
    )
  }
)
